import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/devices/device.service';

@Component({
    selector: 'app-device-dashboard',
    templateUrl: './device-dashboard.component.html',
    standalone: false
})
export class DeviceDashboardComponent implements OnInit, OnDestroy {

  device = '';
  subtype = '';
  loadError = false;
  private routeSubscription?: Subscription;

  constructor(private _aRoute: ActivatedRoute, private _device: DeviceService) {}

  ngOnInit(): void {
    this.routeSubscription = this._aRoute.paramMap.subscribe(paramMap => {
      const serial = paramMap.get('serial') ?? '';
      this.device = serial;
      // Al cambiar de serial Angular reutiliza esta ruta: vaciar el subtipo destruye el dashboard hijo,
      // que si no seguiría suscrito al dispositivo anterior mostrando su estado bajo el serial nuevo.
      this.subtype = '';
      this.loadError = false;
      this._device.getDeviceInfo(serial).subscribe({
        next: (deviceInfo: any) => { if (this.device === serial) this.subtype = deviceInfo.sub_type; },
        error: () => { if (this.device === serial) this.loadError = true; },
      });
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

}

